export default __webpack_public_path__ + "static/bg-tax-c2810b3d9e3716f48543306b77e6d5cd.webp";